angular.module('homebot.directives')

.directive('agentChartPhoto', ['$timeout', function($timeout){
  return {
    restrict: 'E',
    controllerAs: 'agentChartPhotoCtrl',
    bindToController: {
    },
    scope: {},
    templateUrl: '/homes/templates/partials/agent-chart-photo.html',
    controller: function(){ },
    link: function(scope, el, attrs, ctrl){
      console.log(el);
    }
  }
}]);
